var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApprovalsIa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66634 22.1667H6.99967V12.8333H20.9997V22.1667H23.333V9.74167L13.9997 6.00833L4.66634 9.74167V22.1667ZM2.33301 24.5V8.16667L13.9997 3.5L25.6663 8.16667V24.5H18.6663V15.1667H9.33301V24.5H2.33301ZM10.4997 24.5V22.1667H12.833V24.5H10.4997ZM12.833 21V18.6667H15.1663V21H12.833ZM15.1663 24.5V22.1667H17.4997V24.5H15.1663Z",
    fill: "#979797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalsIa);
export default __webpack_public_path__ + "static/media/approvalsIA.32c01df3e54400b3b7f1a6aae26e71f7.svg";
export { ForwardRef as ReactComponent };